import { Text } from '@belong/ui';
import type { ConsumerFailedPaymentModel } from './failed-payments.types';
import {
  formatNegativeFailedPaymentsAmount,
  formatShortDate,
  getBalanceUniqueIds,
  getFailedPaymentsTotal,
} from './failed-payments-utils';
import { FAILED_PAYMENTS_STRINGS } from './failed-payments-strings';

type FailedPaymentBalanceSummaryProps = {
  failedPayments: ConsumerFailedPaymentModel[];
};

export function FailedPaymentBalanceSummary({
  failedPayments,
}: FailedPaymentBalanceSummaryProps) {
  const total = getFailedPaymentsTotal(failedPayments);

  return (
    <div className="flex flex-col gap-sm">
      <div className="flex flex-col gap-sm">
        {failedPayments.map((failedPayment, index) => {
          const balanceUniqueId =
            getBalanceUniqueIds(failedPayment)[0] ??
            failedPayment.label ??
            index;
          const failedDate = formatShortDate(failedPayment.failedOn);

          return (
            <div
              key={balanceUniqueId}
              className="flex items-start justify-between gap-md"
            >
              <div className="flex min-w-0 flex-1 flex-col gap-2xs">
                <Text fontWeight="semibold" className="truncate">
                  {failedPayment.label ?? ''}
                </Text>
                <Text variant="p2" fontWeight="semibold" className="text-red">
                  {failedDate
                    ? `${FAILED_PAYMENTS_STRINGS['item.failed_prefix']} ${failedDate}`
                    : FAILED_PAYMENTS_STRINGS['modal.entry.badge']}
                </Text>
              </div>
              <Text fontWeight="semibold" className="shrink-0 text-right">
                {formatNegativeFailedPaymentsAmount(failedPayment.amount ?? 0)}
              </Text>
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between border-0 border-t border-dashed border-gray pt-sm">
        <Text fontWeight="semibold">
          {FAILED_PAYMENTS_STRINGS['section.total']}
        </Text>
        <Text fontWeight="semibold" className="text-right">
          {formatNegativeFailedPaymentsAmount(total)}
        </Text>
      </div>
    </div>
  );
}
